import styled from 'styled-components';
import Card from '$app/components/vendor/Card';
import Title from '../../../components/Title';

const colors = {
  'light-gray': '#D1DADE',
  'content-black': '#201E1E',
};

export const GalleryContainer = styled.div`
  border-radius: 3px;
  .ant-card-bordered {
    border: 1px solid ${colors['light-gray']};
  }
  .thumbs-container{
    padding: 0 12px;
  }
`;


export const GalleryCard = styled(Card)`
  margin-bottom: 0;
  padding: 16px 0 0 0;
  h1 {
    padding-left: 16px;
  }
`;

export const GalleryTitle = styled(Title)`
  padding-left: 16px;
`;
